import { render } from "./edit-client-type.vue?vue&type=template&id=2fcfdff7&lang=html"
import script from "./edit-client-type.vue?vue&type=script&lang=js"
export * from "./edit-client-type.vue?vue&type=script&lang=js"

import "./edit-client-type.vue?vue&type=style&index=0&id=2fcfdff7&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__